import { useEffect, useState } from "react";
import axios from "axios";
import moment from "moment";
import { headersAuth } from "./revalidacionUtils";

const URL_REVS = process.env.REACT_APP_URL_REVALIDACIONES;

// Rango de ETA por defecto: los que llegaron hace 60 días y los que llegan en los próximos 30
export const RANGO_DEFAULT = {
  inicio: moment().subtract(60, "days").format("YYYY-MM-DD"),
  fin: moment().add(30, "days").format("YYYY-MM-DD"),
};

export const PRESETS_ETA = [
  { label: "Próximos 15 días", rango: () => [moment(), moment().add(15, "days")] },
  { label: "Este mes", rango: () => [moment().startOf("month"), moment().endOf("month")] },
  { label: "-60 / +30 días", rango: () => [moment().subtract(60, "days"), moment().add(30, "days")] },
  { label: "Este año", rango: () => [moment().startOf("year"), moment().endOf("year")] },
];

export default function useRevalidaciones(inicio, fin) {
  const [filas, setFilas] = useState([]);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    let vivo = true;
    setCargando(true);
    axios
      .get(`${URL_REVS}/${inicio}/${fin}`, { headers: headersAuth() })
      .then(({ data }) => vivo && setFilas(Array.isArray(data) ? data : []))
      .catch((err) => {
        console.log(err);
        if (vivo) setFilas([]);
      })
      .finally(() => vivo && setCargando(false));
    return () => { vivo = false; };
  }, [inicio, fin]);

  // Reemplaza el renglón guardado sin volver a pedir todo
  const actualizaFila = (fila) =>
    setFilas((fs) => fs.map((f) => (String(f.contenedor._id) === String(fila.contenedor._id) ? { ...fila, revalidacion: { ...fila.revalidacion, historial: undefined } } : f)));

  return { filas, cargando, actualizaFila };
}
